import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import { API_URL } from "../../../../../constants";
import { Table, Form } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import ExportToExcel from "../../../../../components/ExportToExcel";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Dynamic_FilterForm from "../../../../../components/Dynamic_FilterForm";

const ResourceAllocation = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Resource Allocation"));
  }, []);

  const [resource, setResource] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emp, setEmp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [clientListData, setClientListData] = useState([]);
  const [projectListData, setProjectListData] = useState([]);
  const [selectedClientID, setSelectedClientID] = useState(null);
  const [selectedProjectID, setSelectedProjectID] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [columnVisibility, setColumnVisibility] = useState({
    employeeName: true,
    fromDate: true,
    toDate: true,
    role: true,
    billingRate: true,
    action: true,
  });
  const columns = [
    { id: "employeeName", label: "Resource Name", accessor: "EmployeeName" },
    {
      id: "fromDate",
      label: "From Date",
      accessor: "FromDate",
      format: (val) => moment(val).format("DD-MM-YYYY"),
    },
    {
      id: "toDate",
      label: "To Date",
      accessor: "ToDate",
      format: (val) => moment(val).format("DD-MM-YYYY"),
    },
    { id: "role", label: "Role", accessor: "Role" },
    { id: "billingRate", label: "Billing Rate", accessor: "InvoiceRate" },
    { id: "action", label: "Action", accessor: "" },
  ];

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };
  const filters = {
    Employee: 0,
  };
  const [filter, setFilter] = useState(filters);

  useEffect(() => {
    fetchResourceReport();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchResourceReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}resourceallocation?P_ProjectID&P_ClientID`
      );
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching resource report:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}resourceallocation-getdata`
      );
      if (response?.status === 200) {
        //   Client List
        const clientList = response?.data?.clientlist.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setClientListData(clientList);
        //   Project List
        const projectList = response?.data?.projectlist.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setProjectListData(projectList);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Resource Allocation:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const HandleFilter = () => {
    if (selectedClientID || selectedProjectID) {
      fetchResourceReport(selectedClientID, selectedProjectID);
    }
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return resource.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [resource, searchTerm]);

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    return filteredData.slice(startIndex, endIndex);
  };

  const currentItems = getCurrentItems();

  // Create nested structure for display from the current paginated items
  const nestedData = useMemo(() => {
    return currentItems.reduce((acc, item) => {
      if (!acc[item.ClientName]) {
        acc[item.ClientName] = {};
      }
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});
  }, [currentItems]);

  const [activeClientKeys, setActiveClientKeys] = useState([]);
  const [activeProjectKeys, setActiveProjectKeys] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);
  const [loading,setLoading] = useState(false)
  // Create nested structure for display

  useEffect(() => {
    if (!loading && Object.keys(nestedData).length > 0 && !isInitialized) {
      const allClientKeys = Object.keys(nestedData).map((_, i) => i.toString());
      setActiveClientKeys(allClientKeys);

      const allProjectKeys = {};
      Object.entries(nestedData).forEach(([_, projects], clientIndex) => {
        allProjectKeys[clientIndex.toString()] = Object.keys(projects).map((_, i) => i.toString());
      });

      setActiveProjectKeys(allProjectKeys);
      setIsInitialized(true);
    }
  }, [nestedData, loading, isInitialized]);
 const handleClientToggle = (clientKey) => {
    setActiveClientKeys((prev) =>
      prev.includes(clientKey)
        ? prev.filter((key) => key !== clientKey)
        : [...prev, clientKey]
    );
  };


 const handleProjectToggle = (clientKey, projectKey) => {
  console.log("clientKey, projectKey",clientKey, projectKey);
  
  if (!projectKey) return; // Guard clause

  setActiveProjectKeys((prev) => {
    const current = prev[clientKey] || [];
    return {
      ...prev,
      [clientKey]: current.includes(projectKey)
        ? current.filter((k) => k !== projectKey) // collapse
        : [...current, projectKey],               // expand
    };
  });
};

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];



  const formDatas = [
    {
      name: "Client",
      type: "Select",
      options: [...clientListData],
    },
    {
      name: "Project",
      type: "Select",
      options: [...projectListData],
    },

  ];
  const [filterFormData, setFilterData] = useState([]);
  console.log("filterFormData", filterFormData);

  const handleChange = (e, name) => {
    console.log("tests the server", e, name);

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}resourceallocation?P_ProjectID=${filterFormData.find((o) => o.label === "Project")
          ? filterFormData.find((o) => o.label === "Project").value
          : ""
        }&P_ClientID=${filterFormData.find((o) => o.label === "Client")
          ? filterFormData.find((o) => o.label === "Client").value
          : ""
        }`
      );
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching resource report:", error);
    }
  }


  const handleReset = () => {

    setFilterData([])
    fetchResourceReport()

  }
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="table-responsive">
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div className="me-1">
                    <SearchBar
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <div className="dropdown">
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                    >
                      <button
                        className="dropdown-toggle"
                        type="button"
                        id="excel-btn"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="bi bi-funnel-fill"></i>
                      </button>
                    </OverlayTrigger>

                    <div>
                      <Dynamic_FilterForm
                        formData={formDatas || []}
                        handleReset={handleReset}
                        handleChange={handleChange}
                        handleGetData={handleGetData}
                        filterFormData={filterFormData}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="me-1">
                    <ExportToExcel
                      data={resource}
                      filename="ResourceReport.csv"
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="me-1">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top">Column Chooser</Tooltip>
                        }
                      >
                        <div className="btn-group me-2">
                          <button
                            type="button"
                            className="dropdown-toggle skill-button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            id="excel-btn"
                          >
                            <i className="bi bi-list"></i>
                          </button>
                          <ul className="dropdown-menu p-2">
                            <div className="row">
                              <Form.Group>
                                {columns.map((column) => (
                                  <Form.Check
                                    key={column.id}
                                    type="checkbox"
                                    id={`checkbox-${column.id}`}
                                    label={column.label}
                                    checked={columnVisibility[column.id]}
                                    onChange={() =>
                                      toggleColumnVisibility(column.id)
                                    }
                                  />
                                ))}
                              </Form.Group>
                            </div>
                          </ul>
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            <Table bordered hover>
  <thead id="thcolor" className="text-center">
    <tr>
      <th style={{ width: "60px" }}>##</th>
      <th style={{ width: "100px" }}>Resource Name</th>
      <th style={{ width: "100px" }}>From </th>
      <th style={{ width: "100px" }}>To </th>
      <th style={{ width: "100px" }}>Role</th>
      <th style={{ width: "100px" }}>Billing Rate</th>
      <th style={{ width: "100px" }}>Action</th>
    </tr>
  </thead>
  <tbody>
    {Object.keys(nestedData).length === 0 ? (
      <tr>
        <td colSpan={8} className="text-center text-muted py-3">
          No Record Found
        </td>
      </tr>
    ) : (
      Object.entries(nestedData).map(([clientName, projects], clientIndex) => (
        <React.Fragment key={clientIndex}>
          <tr>
            <td colSpan={8} className="px-0" style={{ padding: "0px !important" }}>
              <Accordion 
               activeKey={activeClientKeys}
  onSelect={() => handleClientToggle(clientIndex.toString())}
  alwaysOpen
              >
                <Accordion.Item eventKey={clientIndex.toString()}>
                  <Accordion.Header className="AccordioninvoiceClient_header">
                    <span className="me-2 accordion_icon">
                     <FontAwesomeIcon
  icon={
    activeClientKeys.includes(clientIndex.toString())
      ? faMinus
      : faPlus
  }
/>

                    </span>
                    <div className="flex-grow-1 text-dark fw-bold">
                      {clientName}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className="no-padding">
                    <Accordion
       activeKey={activeProjectKeys[clientIndex.toString()] || []}
  onSelect={(key) => handleProjectToggle(clientIndex.toString(), key)}
  alwaysOpen
                    >
                      {Object.entries(projects).map(([projectName, items], projectIndex) => (
                        <Accordion.Item
                          eventKey={projectIndex.toString()}
                          key={projectIndex}
                        >
                          <Accordion.Header>
                            <div className="flex-grow-1 px-8 text-dark">
                              {projectName}
                              <span className="text-muted">
                                {" "}
                                (SOW/PO/SO {items[0]?.ProjectInvoiceDetailNumber || "N/A"})
                              </span>
                            </div>
                            <span className="me-2 accordion_icon">
                             <FontAwesomeIcon
  icon={
    activeProjectKeys[clientIndex]?.includes(projectIndex.toString())
      ? faMinus
      : faPlus
  }
/>

                            </span>
                          </Accordion.Header>
                          <Accordion.Body className="no-padding">
                            <Table bordered  >
                              <tbody>
                                {items.map((data, subIndex) => (
                                  <tr key={subIndex} className="border">
                                    <td style={{ width: "60px" }}></td>
                                    {columnVisibility.employeeName && (
                                      <td style={{ width: "100px" }}>
                                        {data.EmployeeName || ""}
                                      </td>
                                    )}
                                    {columnVisibility.fromDate && (
                                      <td className="text-center" style={{ width: "100px" }}>
                                        {moment(data.FromDate).format("DD-MMM-YYYY")}
                                      </td>
                                    )}
                                    {columnVisibility.toDate && (
                                      <td className="text-center" style={{ width: "100px" }}>
                                        {moment(data.ToDate).format("DD-MMM-YYYY")}
                                      </td>
                                    )}
                                    {columnVisibility.role && (
                                      <td style={{ width: "100px" }}>
                                        {data.Role || ""}
                                      </td>
                                    )}
                                    {columnVisibility.billingRate && (
                                      <td className="text-end" style={{ width: "100px" }}>
                                        {data.InvoiceRate || ""}
                                      </td>
                                    )}
                                    {columnVisibility.action && (
                                      <td style={{ width: "100px" }}>
                                        {/* Action buttons if any */}
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </td>
          </tr>
        </React.Fragment>
      ))
    )}
  </tbody>
</Table>
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <span className="d-flex align-items-center">
                    Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                    {Math.min(currentPage * itemsPerPage, filteredData.length)}{" "}
                    of {filteredData.length}{" "}
                    <span className="ms-1">results</span>
                    <select
                      value={itemsPerPage}
                      onChange={(e) => {
                        const newItemsPerPage = Number(e.target.value);
                        setItemsPerPage(newItemsPerPage);
                        setCurrentPage(1); // Reset to first page when changing items per page
                      }}
                      className="mx-2 form-select-sm"
                    >
                      {recordsPerPageOption.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                <div>
                  <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ResourceAllocation;
